import {RemotePostHealthRequestSchedule} from 'data/usecases/private/booking-flow/health/remote-post-health-request-schedule';
import {PostHealthRequestSchedule} from 'domain/usecases/private/booking-flow/health/post-health-request-schedule';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {BookingFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makePostHealthRequestSchedule = (): PostHealthRequestSchedule =>
	new RemotePostHealthRequestSchedule(
		makeBFFApiUrl(BookingFlowEndPoints.healthRequestSchedule),
		makeAuthorizeHttpClientDecorator(),
	);
